var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModelPartForm',{attrs:{"model_part":null,"glass_id":_vm.glass_id,"readOnly":false}})}
var staticRenderFns = []

export { render, staticRenderFns }